<script setup lang="ts">
  import { navigateToStartPage } from '@/router/actions/navigateToStartPage'
  import OnboardingSliderPage from './components/OnboardingSliderPage.vue'
  import OnboardingVideoSlide from './components/OnboardingVideoSlide.vue'
  import OnboardingLottieSlide from './components/OnboardingLottieSlide.vue'
  // Import Lottie animation data
  import onboardingClockerAnimation from '@/assets/lottie/new-onboarding/onboarding_clocker.json'
  import onboardingMessageAnimation from '@/assets/lottie/new-onboarding/onboarding_message.json'
  import { useI18n } from 'vue-i18n'
  import { LocalizedVideo } from '@/classes/LocalizedVideo'
  import PushNotificationManager from '@/classes/manager/PushNotificationManager'

  const { t } = useI18n()

  const localizedVideo = new LocalizedVideo({
    de: 'https://app.clockin.de/static/Mobile-Onboarding-Start.mp4',
  })
  const videoSrc = localizedVideo.getCurrentLocaleVideoSrc()

  async function start() {
    await PushNotificationManager.start()
    void navigateToStartPage()
  }
</script>
<template>
  <onboarding-slider-page
    :finish-button-text="
      t('phrases.new_onboarding.personal_app_manager.button.lets_go')
    "
    @finish="start"
    @skip="start"
  >
    <onboarding-video-slide
      :src="videoSrc"
      :autoplay="true"
      :loop="false"
      :muted="false"
      :headline="
        t('phrases.new_onboarding.personal_app_manager.heading.welcome')
      "
    ></onboarding-video-slide>
    <onboarding-lottie-slide
      :headline="
        t('phrases.new_onboarding.personal_app_manager.heading.clocking_time')
      "
      :text="
        t('phrases.new_onboarding.personal_app_manager.text.clocking_time')
      "
      :animation-data="onboardingClockerAnimation"
    ></onboarding-lottie-slide>
    <onboarding-lottie-slide
      :headline="
        t(
          'phrases.new_onboarding.personal_app_manager.heading.push_notifications',
        )
      "
      :text="
        t('phrases.new_onboarding.personal_app_manager.text.push_notifications')
      "
      :animation-data="onboardingMessageAnimation"
    ></onboarding-lottie-slide>
  </onboarding-slider-page>
</template>
<style scoped></style>
